// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminSearch = (client) => ({
    /**
     * `GET /admin/search`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSearch
     * @source apps/backend/src/api/admin/search/route.ts
     */
    list: (query, headers) => client.fetch("/admin/search", { method: "GET", query, headers }),
    /**
     * `POST /admin/search/reindex`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminReindexSearch
     * @source apps/backend/src/api/admin/search/reindex/route.ts
     */
    updateReindex: (body, query, headers) => client.fetch("/admin/search/reindex", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=search.js.map